import axios from 'axios';
import router from '@/router';

export default {
  namespaced: true,  // home
  state: {
    token: sessionStorage.getItem('ACCESS_TOKEN') || '',
    user: JSON.parse(sessionStorage.getItem('account_user') || '{}'), // 账户信息
    orgs: JSON.parse(sessionStorage.getItem('account_orgs') || '[]'), // 公司列表
    platforms: JSON.parse(sessionStorage.getItem('account_platforms') || '[]'), // 产品列表
    permissions: JSON.parse(sessionStorage.getItem('permissions') || '[]'), // 权限数组
    navList: JSON.parse(sessionStorage.getItem('navList') || '[]'), // 导航列表,
    routeNameList: JSON.parse(sessionStorage.getItem('routeNameList') || '[]'), // 所有路由名的集合
    // 导航类型
    navType: 'horizontal', // horizontal 横向   vertical 纵向
    // 是否收起导航  '1' 收起  '0' 展开
    navCollapse: sessionStorage.getItem('navCollapse') || '0',
    // 导航是否暂时收起 '1' 收起  '0' 展开 (navCollapse为'0'时使用)
    tempCollapse: '1', // 不保存sessionStorage，否则暂时展开时刷新样式不恢复收起
  },
  mutations: {
    setState(state, [ key, data ]) { state[key] = data },
    logout(state) {
      // 清除数据
      axios.defaults.headers.common['Authorization'] = '';
      sessionStorage.clear();
      state.token = '';
      state.currentToken = '';
      state.user = {};
      state.currentUser = '';
      state.orgs = [];
      state.platforms = [];
      state.permissions = [];
      state.navList = [];
      state.routeNameList = [];
      // 跳转登录页
      router.push({ name: 'login' });
    }
  }
}
